/**
* DevExpress HTML/JS Reporting (viewer\parameters\multiValuesHelper.js)
* Version:  22.2.6
* Build date: Apr 17, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { compareArrays } from '@devexpress/analytics-core/analytics-internal';
import * as ko from 'knockout';
export class MultiValuesHelper {
    constructor(value, items, selectAllValues) {
        this.items = items;
        this.selectedItems = ko.observableArray([]);
        this.value = value;
        this.dataSource = items;
        var allValues;
        this.maxDisplayedTags = Math.min(((items && items.length) || 1) - 1, MultiValuesHelper.maxDisplayedTags);
        this.isSelectedAll = ko.pureComputed({
            read: () => this.value().length == items.length,
            write: (selectAll) => {
                var newValue = selectAll ? (allValues || (allValues = items.map(x => x.value))) : [];
                if (!compareArrays(this.value.peek(), newValue))
                    this.value(newValue);
            }
        });
        if (selectAllValues)
            this.isSelectedAll(true);
    }
}
MultiValuesHelper.maxDisplayedTags = 3;
